
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Logo e descrição */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-teal-600 rounded-lg p-2">
                <i className="ri-calculator-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold">CalculaDP</span>
            </div>
            <p className="text-gray-400 mb-6">
              O sistema completo para cálculos de pontos, rescisão, inss, irrf e muito mais. 
              Usado por mais de 500 profissionais.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Produto */}
          <div>
            <h3 className="text-lg font-bold mb-6">Produto</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://calculadp.tiagonogueira.com.br/ponto" className="text-gray-400 hover:text-white transition-colors">
                  Cálculo de Ponto
                </a>
              </li>
              <li>
                <a href="https://calculadp.tiagonogueira.com.br/rescisao-login" className="text-gray-400 hover:text-white transition-colors">
                  Preços
                </a>
              </li>
              <li>
                <a href="https://calculadp.tiagonogueira.com.br/calculadora-salario" className="text-gray-400 hover:text-white transition-colors">
                  Depoimentos
                </a>
              </li>
              <li>
                <a href="https://calculadp.tiagonogueira.com.br/olerith" className="text-gray-400 hover:text-white transition-colors">
                  Demo Gratuita
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-bold mb-6">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Termos de Uso
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Política de Reembolso
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  LGPD
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div className="bg-gray-800 rounded-2xl p-8 mb-12">
          <div className="text-center max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">
              T.I. Contábil
            </h3>
            <p className="text-gray-400 mb-6">
              Tecnologia da Informação para Escritórios de Contabilidade
            </p>
          </div>
        </div>

        {/* Rodapé */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} CalculaDP. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-shield-check-line text-green-400"></i>
                <span>Site Seguro</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-customer-service-2-line text-teal-400"></i>
                <span>Suporte Online</span>
              </div>
              <a 
                href="https://readdy.ai/?ref=logo" 
                className="text-gray-500 hover:text-gray-400 text-xs transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Powered by Tiago Nogueira
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
